export default __webpack_public_path__ + "static/media/calendar.6b791b41.svg";